<template>
  <div class="components-page__approveTable">
    <div v-for="(item, index) of templateDetail" :key="index">
      <!-- 表单 -->
      <descriptionsList v-if="item.type === 'form'" :data="item.data" :column="3" border />
      <!-- 表格 -->
      <table v-if="item.type === 'table'" class="audit-detail-table">
        <tbody>
          <tr>
            <td
              v-for="(tableItem, index) in item.data"
              :key="index"
              class="td-label clear-border"
            >
              {{ tableItem.label }}
            </td>
          </tr>
        </tbody>
      </table>
      <br />
    </div>
  </div>
</template>

<script>
import descriptionsList from './DescriptionsList/index.vue'
import mixin from '../../../mixins/auditFlowManage'

export default {
  name: 'approveTable',
  mixins: [mixin],
  components: {
    descriptionsList,
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.components-page__approveTable {
  .audit-detail-table {
    font-size: 14px;
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0px;
    td {
      word-break: break-all;
      border: 1px solid #ebeef5;
    }
    .td-label {
      width: 180px;
      border-bottom: 1px solid #ebeef0;
      background: #f7f8fa;
      padding: 10px;
    }
    .pl-10 {
      padding-left: 10px;
    }
    .clear-border {
      border: none;
      border-bottom: 1px solid #ebeef0;
      width: auto;
      max-width: 220px;
    }
  }
}
</style>
